// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { addListener, removeListeners } from "~/lib/signals";

/**
 * @class Horní nadpisová část vizitky
 * @private
 */
export default class SubTitle extends Content {
	constructor(dataObj, options) {
		super(dataObj, options);

		this._gps = Mapy.getComponent("gps");
		this._signals = [];
		this._dom.container.innerHTML = "";

		if (dataObj.data.source == "coor") {
			this._buildCoor();
			this._signals.push(addListener(this, "gps-format-changed", () => {
				this._setFormatSubtitle();
			}));
			this._setFormatSubtitle();
		}
		else {
			let titleSub = [];

			if (dataObj.userTitle && dataObj.userTitle !== dataObj.data.title) {
				titleSub.push(dataObj.origTitle);
			}

			if (dataObj.data.titleSub) {
				titleSub.push(dataObj.data.titleSub);
			}

			if (titleSub.length) {
				this._dom.container.classList.add("content-subtitle");
				this._dom.h2 = Mapy.Util.node("h2", {
					textContent: titleSub.join(", ")
				});
				this._dom.container.appendChild(this._dom.h2);
			}
		}
	}

	destroy() {
		removeListeners(this._signals);
	}

	_buildCoor() {
		this._dom.container.classList.add("content-subtitle");
		this._dom.h2 = Mapy.Util.node("h2");
		this._dom.container.appendChild(this._dom.h2);
	}

	_setFormatSubtitle() {
		this._dom.container.setAttribute("x-ms-format-detection", "none");
		this._dom.h2.textContent = this._gps.coordsToFormat(this._data.coords);
	}
}
